<template>
  <li class="upload-module-draggable">
    <button
      :aria-describedby="`upload-module-draggable__aria-description--${uniqueId}`"
      class="upload-module-draggable__button"
      @click="openMyContentUploadModal"
    >
      {{ $t('Upload from My Device') }}
    </button>
    <span
      class="upload-module-draggable__aria-description"
      :id="`upload-module-draggable__aria-description--${uniqueId}`"
    >
      {{ $t('Press Enter to upload a file from your device') }}
    </span>
  </li>
</template>

<script>
import { uniqueId } from 'lodash-es';
import { mapActions, mapState } from 'pinia';
import {
  useModalStore,
  useUserStore,
} from '@/stores';
import * as types from '@/lib/constants/store';

export default {
  name: 'UploadModuleDraggable',
  props: {
    allowMultiple: Boolean,
    canvasName: {
      type: String,
      required: true,
    },
    moduleToReplace: {
      type: Object,
      required: false,
      default: null,
    },
    options: {
      type: Object, // these options are used when dragging rather than in this component
      required: true,
    },
    uploadCallback: {
      type: Function,
      default: null,
    },
  },
  emits: ['assetsUploaded'],
  data() {
    return {
      uniqueId: uniqueId(),
    };
  },
  computed: {
    ...mapState(useUserStore, [
      'domains',
      'isDeUser',
    ]),
  },
  methods: {
    ...mapActions(useModalStore, [
      types.OPEN_MODAL,
    ]),
    openMyContentUploadModal() {
      const vm = this;

      if (this.isDeUser) {
        this[types.OPEN_MODAL]({
          type: 'EditorialUploadInfo',
          allowMultiple: this.allowMultiple,
          canvasName: this.canvasName,
          moduleToReplace: this.moduleToReplace,
        });
      } else {
        this[types.OPEN_MODAL]({
          type: 'MyContentUploadModal',
          allowMultiple: this.allowMultiple,
          baseURL: this.domains.deDomain,
          onAssetsUploaded(assets) {
            const formattedAssets = assets.map((asset) => ({
              ...asset,
              is_user_created: true,
            }));

            if (vm.uploadCallback) {
              vm.uploadCallback(formattedAssets);
            } else {
              vm.$emit('assetsUploaded', formattedAssets);
            }
          },
        });
      }
    },
  },
};
</script>

<style lang="stylus">
.upload-module-draggable {
  list-style-type: none;
  position: relative;

  &__button {
    background: transparent;
    border: 0;
    padding: $nebula-space-1x $nebula-space-2x;
    text-align: left;
    transition: background $nebula-transition-default;
    width: 100%;

    &:hover, &:focus {
      background-color: $comet-color-neutral-95;
    }
  }

  &__aria-description {
    display: none;
  }
}
</style>
